export default __webpack_public_path__ + "static/EMAp-bcbfededb9eb3998f26e4e43f9e48b3c.png";